import React from 'react';
import type { IERPUser } from '@admin-panel/types';
import { WarehouseFacilitySelector } from '../../header';
import SettingsSection from './SettingsSection';

type Props = {
  user?: IERPUser;
};

const WarehouseGeneralSettings: React.FC<Props> = ({ user }) => (
  <SettingsSection
    title="Facility access"
    description="Switch the active warehouse/facility for this session."
  >
    <WarehouseFacilitySelector user={user} />
  </SettingsSection>
);

export default WarehouseGeneralSettings;
